import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ApresentacaoSistemaRoutingModule } from './apresentacao-sistema-routing.module';
import { ApresentacaoSistemaComponent } from './apresentacao-sistema.component';
import { ContainerPadraoModule } from '../../shared/components/container-padrao/container-padrao.module';
import { ButtonModule } from '../../shared/components/button/button.module';

@NgModule({
    declarations: [ApresentacaoSistemaComponent],
    imports: [CommonModule, ApresentacaoSistemaRoutingModule, ContainerPadraoModule, ButtonModule]
})
export class ApresentacaoSistemaModule {}
